import React from 'react';

const SelectOption = ({ value, label }) => (
    <div style={{ display: "flex" }}>
        <span style={{minHeight: "1em"}} type={value} size="medium">{label}</span>
    </div>
);

export default SelectOption;